import React, {PropsWithChildren} from 'react';
import {ColumnComponent} from './base/column.component';

interface Props {
  className?: string;
}

export function RTLContainer(props: PropsWithChildren<Props>): JSX.Element {
  return <ColumnComponent className={props.className}>{props.children}</ColumnComponent>;
}
